// Country code to full name mapping
const COUNTRY_NAMES = {
  CA: 'Canada',
  US: 'United States',
  AR: 'Argentina',
  AU: 'Australia',
  BE: 'Belgium',
  BR: 'Brazil',
  ES: 'Spain',
  FR: 'France',
  GR: 'Greece',
  IT: 'Italy',
  MX: 'Mexico',
  NZ: 'New Zealand',
  PT: 'Portugal',
  SA: 'Saudi Arabia',
  UK: 'United Kingdom',
};

// Priority countries appear first in dropdowns
const PRIORITY_COUNTRIES = ['CA', 'US'];

export function getCountryName(code) {
  return COUNTRY_NAMES[code] || code;
}

export function sortCountries(codes) {
  const priority = codes.filter(c => PRIORITY_COUNTRIES.includes(c));
  const rest = codes.filter(c => !PRIORITY_COUNTRIES.includes(c));
  // Sort priority by defined order, rest alphabetically by name
  priority.sort((a, b) => PRIORITY_COUNTRIES.indexOf(a) - PRIORITY_COUNTRIES.indexOf(b));
  rest.sort((a, b) => getCountryName(a).localeCompare(getCountryName(b)));
  return [...priority, ...rest];
}

// All available country codes (pre-sorted with priority first)
export const ALL_COUNTRIES = sortCountries(Object.keys(COUNTRY_NAMES));
